/**
 * Compares two objects and returns a new object that combines `base`
 * with any null-valued properties from `source` that are absent in `base`.
 *
 * Useful for preserving explicitly-null fields from API/proto responses
 * that may not exist in the base object.
 *
 * Rationale: see ./transport-null.md
 * @see ./transport-null.md
 *
 * @example
 * const obj1 = { a: true, b: "hi", c: [123, "fre", false] };
 * const obj2 = { a: true, b: "hi", c: [123, "fre", false], d: null };
 * transportNullFields(obj1, obj2);
 * // => { a: true, b: "hi", c: [123, "fre", false], d: null }
 */
export function transportNullFields<T extends Record<string, unknown>>(
  base: T,
  source: Record<string, unknown>
): Record<string, unknown> {
  const result: Record<string, unknown> = { ...base };

  for (const key of Object.keys(source)) {
    if (source[key] === null && !(key in base)) {
      result[key] = null;
    }
  }

  return result;
}
